import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';

import './not-found.scss';

class NotFoundTemplate extends PureComponent {
  render() {
    return (
      <div className="not-found">
        <Helmet>
          <title>Страница не найдена</title>
        </Helmet>

        <div className="container">
          <div className="not-found-content">
            <h1>Oops...</h1>

            <h2>
              Страница не найдена <br />
              <i>Ошибка 404</i>
            </h2>

            <p>
              К сожалению, запрашиваемой страницы не существует. Вероятно, она
              была удалена <br />с сервера, либо её не существовало вовсе.
              Попробуйте перейти <Link to="/">в начало.</Link>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFoundTemplate;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFoundTemplate.js